import { AbstractControl, ValidatorFn } from '@angular/forms';

export function isValidPrice(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const price = parseInt(control.value);
        const cost = parseInt(control.parent?.value.cost);
        return (price < cost && { invalidPrice: true }) || null;
    };
}
